<template>
  <div>
    <slot name="header"></slot>
    <v-sheet outlined rounded class="px-5 py-5">
      <v-skeleton-loader type="chip"/>
      <v-row>
        <v-col>
          <v-skeleton-loader type="list-item"/>
        </v-col>
        <v-col>
          <v-skeleton-loader type="list-item"/>
        </v-col>
        <v-col>
          <v-skeleton-loader type="list-item"/>
        </v-col>
        <v-col>
          <v-skeleton-loader type="list-item"/>
        </v-col>
      </v-row>
      <div class="d-flex justify-end mt-1 mb-2">
        <v-skeleton-loader type="button"/>
        <v-skeleton-loader type="button" class="ml-2"/>
      </div>
    </v-sheet>
    <v-skeleton-loader type="table"/>
  </div>
</template>

<script>
/**
 * This is sort of a standard skeleton form for use on all the Index pages.
 */
export default {
  name: 'IndexTableSkeleton'
}
</script>

<style scoped>

</style>
